import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { GoogleTagManagerEnums } from "../../shared/utilities/enums/googleTagManagerEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { ISearchGtmItem, SearchGtmItem } from "./searchGtmItem";


export interface ISearchItemBase extends IInstanceComponentBase {
    searchGtmItem: ISearchGtmItem;
}

export abstract class SearchItemBase extends InstanceComponentBase implements ISearchItemBase {
    private readonly _handleClick;
    public searchGtmItem: ISearchGtmItem;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);
        this._handleClick = this.handleClick.bind(this);

        this.createSearchGtmItemFactory();

        this.attachClickEventListener();
    }

    attachClickEventListener(): void {
        this.htmlElement.querySelector('a').addEventListener('click', this._handleClick);
    }
    removeClickEventListener(): void {
        this.htmlElement.querySelector('a').removeEventListener('click', this._handleClick);
    }
    handleClick(event: Event, listValue: GoogleTagManagerEnums.SearchClickListValues): void {
        try {
            this.searchGtmItem.sendSearchProductAndPageClickGtmDataObjectAndNavigate(listValue);
        } catch (error) {
            document.location = this.htmlElement.querySelector('a').getAttribute('href');
        }
    }

    createSearchGtmItemFactory() {
        try {
            let searchGtmItemElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.SearchGtm.GtmSearchItem)) as HTMLElement;
            this.searchGtmItem = new SearchGtmItem(searchGtmItemElement);

        } catch (error) {
            console.log("SearchItemBase: createSearchGtmItemFactory ERROR: ", error);
        }
    }

    dispose(): void {
        this.removeClickEventListener();
    }
}